import React from 'react';
import UserContext from './UserContext';

function withUser(WrappedComponent) {
  const HOC = props => (
    <UserContext.Consumer>
      {context => {
        return <WrappedComponent {...props} {...context} />;
      }}
    </UserContext.Consumer>
  );

  return HOC;
}

export default withUser;



// WEBPACK FOOTER //
// ./src/components/context/withUser.js